export default "__VITE_ASSET__CMi8RK8m__"